"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Modal/index"), exports);
var index_1 = require("./components/Modal/index");
exports.default = index_1.Modal;
//# sourceMappingURL=Modal.js.map